import { gql } from '@apollo/client';

export const GetObjectGroupObjectsQueryName = 'GetObjectGroupObjects';

export const GET_OBJECT_GROUP_OBJECTS_QUERY = gql`
  query ${GetObjectGroupObjectsQueryName}($groupId: String!) {
    getMyObjects(groupId: $groupId) {
      id
      name
      type
      siteId
      siteStatus
      groupId
      updatedAt
    }
  }
`;
